import {
  DEVICE_STATISTICS_CHANGE
} from '../constants/ActionTypes';


export const onDeviceStatisticsChange = (value) => {
  return {
    type: DEVICE_STATISTICS_CHANGE,
    payload:value
  };
};
